'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CurrencyConverter = function () {
  function CurrencyConverter() {
    _classCallCheck(this, CurrencyConverter);
  }

  _createClass(CurrencyConverter, null, [{
    key: 'Cast',
    value: function Cast(value, language, postCom) {
      //value:Wert als Int, language:Sprache als Kürzel, postCom:gewünschte Anzahl an Nachkommastellen als Int

      // nur Übergangsweise "Lösung"
      function auffuellen(pos1, value1, nachKommaAkt1, postCom1) {
        var i = void 0;
        if (pos1 < 0) {
          value1 = value1 + '.';
        }
        for (i = nachKommaAkt1; i < postCom1; ++i) {
          value1 = value1 + '0';
        }
        return value1 + ' €';
      }

      function runde(x, n) {
        //http://www.dcljs.de/faq/antwort.php?Antwort=rechnen_runden#5
        if (n < 0 || n > 14) {
          return false;
        }
        var e = Math.pow(10, n);
        var k = (Math.round(x * e) / e).toString();
        if (k.indexOf('.') === -1) {
          k += '.';
        }
        k += e.toString().substring(1);
        var wert = k.substring(0, k.indexOf('.') + n + 1);
        if (n === 0) {
          wert = wert.substring(0, k.indexOf('.'));
        }
        return wert + ' €';
      }

      var pos = String(value).indexOf('.'); //Position von '.'
      var nachKommaAkt = void 0; //Anzahl Stellen nach dem Komma aktuell

      if (pos > 0) {
        nachKommaAkt = String(value).length - pos - 1;
      } else {
        nachKommaAkt = 0;
      }

      switch (language) {
        case 'en':
          if (nachKommaAkt < postCom) {
            return auffuellen(pos, value, nachKommaAkt, postCom);
          } else if (nachKommaAkt > postCom) {
            return runde(value, postCom);
          } else {
            return value + ' €';
          }

        case 'de':

          if (nachKommaAkt < postCom) {
            return String(auffuellen(pos, value, nachKommaAkt, postCom)).replace('.', ',');
          } else if (nachKommaAkt > postCom) {
            return String(runde(value, postCom)).replace('.', ',');
          } else {
            return String(value).replace('.', ',') + ' €';
          }

        default:
          break;
      }
    }
  }]);

  return CurrencyConverter;
}();

exports.default = CurrencyConverter;